import {Component, Inject, OnInit} from '@angular/core';
import {BackendApiService} from "../../../../../services/backend-api.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ToasterService} from "../../../../../services/core/toaster.service";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-proposal-unlock',
    templateUrl: './proposal-unlock.component.html',
    styleUrls: ['./proposal-unlock.component.scss'],
    standalone: false
})
export class ProposalUnlockComponent implements OnInit {

  model: any = {};
  is_locked: any = 0;
  title: any = '';
  url: any = '';
  public sectionForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl(null, []),
    password: new UntypedFormControl(null, []),
  })
  constructor(
    public dialogRef: MatDialogRef<ProposalUnlockComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public backendApiService: BackendApiService,
    public toasterService: ToasterService
  ) {
    this.model = this.data?.model;
    this.is_locked = this.data?.is_locked ;
    this.title = this.data?.title ;
    this.url = this.data?.url ;
    console.log(this.data)
  }

  ngOnInit(): void {
  }

  getFormData() {
    const form = this.sectionForm?.value;
    return {
      // username: form?.email,
      // password: form?.password,
      is_locked: this.is_locked.toString()
    }
  }

  unlock() {
    this.backendApiService.postApi(this.url,this.getFormData())
      .subscribe((response: any) => {
        this.toasterService.showSuccessMessage(response?.data?.message);
        this.close(true)
      })
  }

  close(data: any = null){
    this.dialogRef.close(data)
  }

}
